

<template>
      
      

  <div class="row">
  <div class="col-sm-3 col-lg-3 col-xxl-3" v-for="firma in paginatedfirmalar" :key="firma.id"  :class="{ 'tableactivetr': firma.id === (firmalar.secili && firmalar.secili.id) }">
<div class="card card-bordered">
    <div class="card-inner">
        <div class="team">
            <div class="team-status bg-light text-black"></div>
           
            <div class="user-card user-card-s2" @click="detay(firma)">
                <div class="user-avatar md bg-primary"> <img :src="$globalVariable.uploadUrl + firma.logo"  @error="$globalVariable.varsayilanGorsel" alt="">
                </div>
                <div class="user-info">
                    <h6> {{ firma.unvan }}</h6><span class="sub-text">{{ firma.ulke }}</span>
                </div>
            </div>
          
          
            <div class="team-view">
              <a href="#" class="btn btn-trigger btn-icon"  @click="detay(firma)">
            <em class="icon ni ni-eye"></em>
          </a>
              <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('firma_duzenle')" @click="duzenle(firma)">
            <em class="icon ni ni-pen"></em>
          </a>
        
     
          <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('firma_sil')" @click="sil(firma.id)">
            <em class="icon ni ni-trash-alt"></em>
          </a>
          
                  </div>
        </div>
    </div>
</div>
</div>
</div>



<div class="card-inner">
        <div class="nk-block-between-md g-3">
          <div class="g">
            <ul class="pagination justify-content-center justify-content-md-start">
              <li :class="{ active: page === firmalar.seciliSayfa, 'page-item': true }" v-for="page in pages"
                :key="page">
                <a class="page-link" href="#" @click="firmalarSayfaDegistir(page)">{{ page }}</a>
              </li>

            </ul>
          </div>

        </div>
      </div>




   

 </template>
 

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';

export default {
  props: {

    firmalar:{
      type: Array,
      required: true
    },
    duzenle: Function,
    detay: Function,
    formKaydetSonrasi: Function,
    tur:String,
  },
  computed: {
    filteredfirmalar() {
      // Arama filtresine göre kullanıcıları filtrele
      return this.firmalar.tumu.filter(
        (firma) =>

          firma.unvan.toLowerCase() 
          
          .includes(this.firmalar.arananKelime.toLowerCase()) ||firma.unvan.toLowerCase()
          
          .includes(this.firmalar.arananKelime.toLowerCase()) ||firma.telefon.toLowerCase()
          
          .includes(this.firmalar.arananKelime.toLowerCase()) ||firma.email.toLowerCase()
          
          .includes(this.firmalar.arananKelime.toLowerCase()) ||firma.adres.toLowerCase()
          
          .includes(this.firmalar.arananKelime.toLowerCase()) ||firma.not.toLowerCase()
          
          .includes(this.firmalar.arananKelime.toLowerCase()) ||firma.ulke.toLowerCase()
          
          
          .includes(this.firmalar.arananKelime.toLowerCase())


    
      );
    },
    paginatedfirmalar() {
      const start = (this.firmalar.seciliSayfa - 1) * this.firmalar.sayfadaKayit;
      const end = start + this.firmalar.sayfadaKayit;
      return this.filteredfirmalar.slice(start, end);
    },
    firmalar_toplamSayfa() {
      const totalFilteredUsers = this.filteredfirmalar.length;
      const maxPage = Math.max(Math.ceil(totalFilteredUsers / this.firmalar.sayfadaKayit), 1);
      if (this.firmalar.seciliSayfa > maxPage) {
        this.firmalarSayfaDegistir(maxPage);
      }
      return maxPage;
    },
    pages() {
        const totalPageCount = this.firmalar_toplamSayfa;
        const maxVisiblePages = 5;
        const currentPage = this.firmalar.seciliSayfa;

        if (totalPageCount <= maxVisiblePages) {
            return Array.from({ length: totalPageCount }, (_, index) => index + 1);
        }

        const pagesBefore = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
        const pagesAfter = Math.min(pagesBefore + maxVisiblePages - 1, totalPageCount);

        return Array.from({ length: pagesAfter - pagesBefore + 1 }, (_, index) => pagesBefore + index);
    },
  
  },
  methods: {
    yetki_kontrol(yetki){
      return yetkiKontrol(yetki);
    },
    async sil(firmaId) {
      const result = await this.$swal({
        title: "Emin misiniz?",
        text: "Bu işlemi geri alamayacaksınız!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "İptal",
      });

      if (result.isConfirmed) {
        try {
          await axiosCustom.post("firmalar/sil/" + firmaId);
          this.$toast.success("Kayıt Silindi");
          this.formKaydetSonrasi();
        } catch (error) {
          console.error("Silme hatası: ", error);
          this.$toast.error("Silme hatası");
        }
      }
    },
    firmalarSayfaDegistir(page) {
      this.$emit('update:firmalar',{
      ...this.firmalar,
      seciliSayfa: page
    });
    },
    firmalarSayfadaKayitDegistir(value) {
      this.$emit('update:firmalar',{
      ...this.firmalar,
      sayfadaKayit: value
    });
      this.firmalarSayfaDegistir(1);
    },
  },
};
</script>
